<div
	#redactionLayer
	class="redaction-layer"
	[class.redaction-mode]="redactionMode()"
	(pointerdown)="onPointerDown($event)"
	(pointermove)="onPointerMove($event)"
	(pointerup)="onPointerUp($event)"
>
	@for (box of redactionBoxes(); track box) {
		<div
			class="redaction-box"
			[style.left]="box.left + '%'"
			[style.top]="box.top + '%'"
			[style.width]="box.width + '%'"
			[style.height]="box.height + '%'"
			(contextmenu)="removeRedactionBox($event, $index)"
		>
			<div
				class="redaction-box-handle handle-nw"
				(pointerdown)="onResizeHandlePointerDown($event, box, 'nw')"
				aria-hidden="true"
			></div>
			<div
				class="redaction-box-handle handle-n"
				(pointerdown)="onResizeHandlePointerDown($event, box, 'n')"
				aria-hidden="true"
			></div>
			<div
				class="redaction-box-handle handle-ne"
				(pointerdown)="onResizeHandlePointerDown($event, box, 'ne')"
				aria-hidden="true"
			></div>
			<div
				class="redaction-box-handle handle-e"
				(pointerdown)="onResizeHandlePointerDown($event, box, 'e')"
				aria-hidden="true"
			></div>
			<div
				class="redaction-box-handle handle-se"
				(pointerdown)="onResizeHandlePointerDown($event, box, 'se')"
				aria-hidden="true"
			></div>
			<div
				class="redaction-box-handle handle-s"
				(pointerdown)="onResizeHandlePointerDown($event, box, 's')"
				aria-hidden="true"
			></div>
			<div
				class="redaction-box-handle handle-sw"
				(pointerdown)="onResizeHandlePointerDown($event, box, 'sw')"
				aria-hidden="true"
			></div>
			<div
				class="redaction-box-handle handle-w"
				(pointerdown)="onResizeHandlePointerDown($event, box, 'w')"
				aria-hidden="true"
			></div>
		</div>
	}
</div>
